import React from "react";
import { Icomponent } from "../../../core/components/basegame/interface/Icomponent";


interface IframeworkBaseGameReconstruction {
    data: {
        COMPONENTS: Icomponent[]
    }

}

export const frameworkBaseGameReconstruction: IframeworkBaseGameReconstruction = {

    data: {
        "COMPONENTS": [
            {


                "id": "baseGamerReconstructionBanner",
                "name": "baseGamerReconstructionBanner",
                "type": "Container",
                "class": "",
                "x": 650,
                "y": 300,
                "filterTypes": [],
                "visible": false,
                "parentLayer": "specialAnimationLayer",
                child: [

                    {


                        "id": "baseGamerReconstructionDesktop",
                        "name": "baseGamerReconstructionDesktop",
                        "type": "Container",
                        "class": "",
                        "x": 624,
                        "y": 364,
                        "layout": false,
                        "uimode": "desktop",
                        "filterTypes": [],
                        "visible": true,
                        "parentLayer": "specialAnimationLayer",
                        child: [

                            {
                                "name": "popup_reconstruction_desktop",
                                "image": "popupbackground",
                                "type": "Image",
                                "visible": true,
                                "width": 635,
                                "height": 354,
                                "x": 0,
                                "y": 0,
                            },
                            {
                                "id": "popup_reconstruction_text",
                                "name": "popup_reconstruction_text",
                                "type": "Text",
                                "x": 310,
                                "y": 130,
                                "width": 560,
                                "visible": true,
                                "text": "    Your play was interrupted, \n Press ok to continure your bet",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'Oswald-regular',
                                    fontSize: 30,
                                    fontStyle: 'normal',
                                    fill: ['#ffff'],
                                },
                                "parentLayer": "specialAnimationLayer",
                            },
                            {
                                "id": "baseGameSpinbtn",
                                "name": "baseGameSpinbtn",
                                "type": "Image",
                                "buttonMode": true,
                                "interactive": true,
                                "x": 230,
                                "y": 254,
                                "height": 56,
                                "width": 150,
                                "visible": true,
                                "buttonState": {
                                    up: 'popupbackgroundbtn',
                                    out: 'popupbackgroundbtn',
                                    down: 'popupbackgroundbtn',
                                    disable: 'popupbackgroundbtn',
                                    enable: 'popupbackgroundbtn',
                                    hover: 'popupbackgroundbtn'
                                },
                                "hitareaVisible": true,

                            },
                            {
                                "id": "popup_reconstruction_Button_text",
                                "name": "popup_reconstruction_Button_text",
                                "type": "Text",
                                "x": 305,
                                "y": 282,
                                "width": 200,
                                "visible": true,
                                "text": "ui-popup_okay",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'Oswald-regular',
                                    fontSize: 25,
                                    fontStyle: 'normal',
                                    fill: ['#ffff'],
                                },
                                "parentLayer": "specialAnimationLayer",
                            },

                        ]
                    },
                    {


                        "id": "baseGamerReconstructionMobile",
                        "name": "baseGamerReconstructionMobile",
                        "type": "Container",
                        "class": "",
                        "x": 624,
                        "y": 364,
                        "layout": true,
                        "uimode": "mobile",
                        "filterTypes": [],
                        "visible": true,
                        "parentLayer": "specialAnimationLayer",
                        child: [

                            {
                                "name": "popup_reconstruction_desktop",
                                "image": "popupbackground",
                                "type": "Image",
                                "visible": true,
                                "width": 635,
                                "height": 354,
                                "x": 0,
                                "y": 0,
                            },
                            {
                                "id": "popup_reconstruction_text",
                                "name": "popup_reconstruction_text",
                                "type": "Text",
                                "x": 310,
                                "y": 130,
                                "width": 560,
                                "visible": true,
                                "text": "    Your play was interrupted, \n Press ok to continure your bet",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'Oswald-regular',
                                    fontSize: 30,
                                    fontStyle: 'normal',
                                    fill: ['#ffff'],
                                },
                                "parentLayer": "specialAnimationLayer",
                            },
                            {
                                "id": "baseGameSpinbtn",
                                "name": "baseGameSpinbtn",
                                "type": "Image",
                                "buttonMode": true,
                                "interactive": true,
                                "x": 230,
                                "y": 254,
                                "height": 56,
                                "width": 150,

                                "visible": true,

                                "buttonState": {
                                    up: 'popupbackgroundbtn',
                                    out: 'popupbackgroundbtn',
                                    down: 'popupbackgroundbtn',
                                    disable: 'popupbackgroundbtn',
                                    enable: 'popupbackgroundbtn',
                                    hover: 'popupbackgroundbtn'
                                },
                                "hitareaVisible": true,

                            },
                            {
                                "id": "popup_reconstruction_Button_text",
                                "name": "popup_reconstruction_Button_text",
                                "type": "Text",
                                "x": 305,
                                "y": 282,
                                "width": 200,
                                "visible": true,
                                "text": "ui-popup_okay",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'Oswald-regular',
                                    fontSize: 25,
                                    fontStyle: 'normal',
                                    fill: ['#ffff'],
                                },
                                "parentLayer": "specialAnimationLayer",
                            },

                        ]
                    }

                ]
            },


        ]
    }

};

export const BaseGameReconstructionConfigurationContext = React.createContext(
    {}
);